export default __webpack_public_path__ + "static/media/11d.c2483673.jpg";